var _rect, _polygon, _path, _path2, _path3, _polygon2, _polygon3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    x: 12,
    y: 16,
    fill: "#fff",
    transform: "rotate(-90 20 24)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#1e88e5",
    points: "3,17 3,31 8,32 13,31 13,17 8,16"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M37,24v14c0,1.657-1.343,3-3,3H13l-1-5l1-5h14v-7l5-1L37,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc02d",
    d: "M37,10v14H27v-7H13l-1-5l1-5h21C35.657,7,37,8.343,37,10z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1565c0",
    d: "M13,31v10H6c-1.657,0-3-1.343-3-3v-7H13z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#e53935",
    points: "13,7 13,17 3,17"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2e7d32",
    points: "38,24 37,32.45 27,24 37,15.55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M46,10.11v27.78c0,0.84-0.98,1.31-1.63,0.78L37,32.45v-16.9l7.37-6.22C45.02,8.8,46,9.27,46,10.11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeet);
export default __webpack_public_path__ + "static/media/meet.a74ad582e0a434c1af413d9491d85524.svg";
export { ForwardRef as ReactComponent };